var apiCTOModalMsgCms = /** @class */ (function () {
    function apiCTOModalMsgCms() {
        this.content = {
            heading: 'Something isn’t working',
            waitMsg: 'Looks like something went wrong on our end. Please wait a moment and try again',
            callMsg: 'Looks like we hit a snag and need to talk to you before you can continue. Call 800.351.0500 and we\'ll help you resolve the problem.',
            ctnMsg: 'We hit a snag and can\'t activate your device. Questions? Call 800.351.0500.',
            ctnValidationMsg: 'We hit a snag and can\'t activate your device. Please return to BMW and try again.',
            ctnValidationHeading: 'Something went wrong',
            alreadyTwinnedMsg: 'It looks like your phone number is already synced to a vehicle. Please return to BMW and try again with another account.',
            alreadyTwinnedHeading: 'Your number is already synced',
        };
    }
    return apiCTOModalMsgCms;
}());
export { apiCTOModalMsgCms };
export var CTOErrorCodes = {
    BUSINESS_AUTH_ERROR: "BUSINESS_AUTH_ERROR",
    SYSTEM_AUTH_ERROR: "SYSTEM_AUTH_ERROR",
    WLS_TKN_001: "WLS-TKN-VLD-001",
    WLS_TKN_004: "WLS-TKN-VLD-004",
    WLS_TKN_005: "WLS-TKN-VLD-005",
};
//# sourceMappingURL=apiCTOModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/apiCTOModal.cms.js
// module id = 1476
// module chunks = 8